import { JwtToken } from "@sky/xerxes-client-react";
import { AttributeValue, QueryCommand, PutItemCommand, DeleteItemCommand} from "@aws-sdk/client-dynamodb";
import { ListUserPoolClientsCommand, UserPoolClientDescription } from "@aws-sdk/client-cognito-identity-provider";
import { Application, UserRole } from "../model";
import { COGNITO, DYNAMODB } from '../config';
import AwsService from "./AwsService";

export default class ApplicationService extends AwsService {

    public constructor(token: JwtToken) {
        super(token);
    }

    public fetchAll = async (): Promise<Application[]> => {
        const command = new ListUserPoolClientsCommand({ UserPoolId: COGNITO.userPoolId, MaxResults: 50 });
        const response = await this.cognitoClient.send(command);
        
        return (response.UserPoolClients?.map(this.toApplication) || [])
            .sort((a, b) => a.name.localeCompare(b.name));
    }


    public fetchRolesForUser = async (userId: string, clientId: string): Promise<UserRole[]> => {
        const query = new QueryCommand({
            TableName: DYNAMODB.userTableName,
            KeyConditionExpression: 'PK = :PK AND begins_with(SK, :SK)',
            ExpressionAttributeValues: {
                ':PK': { 'S': `sub:${userId}` },
                ':SK': { 'S': `access:${clientId}` }
            }        
        });

        return (await this.ddbClient.send(query)).Items?.map((item: Record<string, AttributeValue>) => ({ 
            role: item['role']['S'],
            partner: item['partnerId']['S'],
            rights: item['rights']['SS']
        } as UserRole)) || [];
    }
    
    public addRoleForUser = async (userId: string, clientId: string, role: UserRole): Promise<any> => {
        const query = new PutItemCommand({
            TableName: DYNAMODB.userTableName,
            Item: {
                PK: { S: `sub:${userId}` },
                SK: { S: `access:${clientId}:${role.partner}:${role.role}` },
                role: { S: role.role },
                partnerId: { S: role.partner },
                clientId: { S: clientId },
                rights: { SS: role.rights },
            }
        });

        return await this.ddbClient.send(query);
    }

    public removeRoleForUser = async (userId: string, clientId: string, role: UserRole) : Promise<any> => {
        const query = new DeleteItemCommand({
            TableName: DYNAMODB.userTableName,
            Key: {
                PK: { S: `sub:${userId}` },
                SK: { S: `access:${clientId}:${role.partner}:${role.role}` }
            }
        });

        return await this.ddbClient.send(query);
    }

    private toApplication = (client: UserPoolClientDescription): Application => {
        return {
            name: client.ClientName,
            clientId: client.ClientId,
        } as Application;
    }

}

